import {
  ADDLIFEDETAILS,
  ADDLIFENUMBER,
  ALLLIFEDETAILS,
  LIFENUMFLAG,
  CUST_DETAIL_LIFE,
  LIFE_QQ_POST,
  LIFE_QUOTE,
  ERROR_QUOTES_LIFE,
  RESET_LIFE,
  LIFE_OFF_REQUEST,
} from "../actiontypes/NumLifeActiontypes";

const init = {
  islifeno: false,
  lifenum: {},
  lifemake: "",
  lifemodel: "",
  lifeyear: "",
  isalllifedetails: false,
  cusInfo: {},
  QuickQuotePost: {},
  quickquotes: [],
  errquote: [],
  offlineRequest: {},
};
export const numLifeReducer = (state = init, { type, payload }) => {
  // console.log(payload);
  switch (type) {
    case ADDLIFENUMBER:
      return { ...state, lifenum: payload, islifeno: false };
    // case LIFENUMFLAG:
    //   return { ...state, lifenum: "", islifeno: false };
    case ADDLIFEDETAILS:
      return {
        ...state,
        lifemake: payload.make,
        lifemodel: payload.model,
        lifeyear: payload.year,
        isalllifedetails: true,
      };
    case ALLLIFEDETAILS:
      return { ...state, isalllifedetails: true };
    case CUST_DETAIL_LIFE:
      return { ...state, cusInfo: payload };
    case LIFE_QQ_POST:
      return { ...state, QuickQuotePost: payload };
    case LIFE_QUOTE:
      return { ...state, quickquotes: payload };
    case ERROR_QUOTES_LIFE:
      return { ...state, errquote: payload };
    case LIFE_OFF_REQUEST:
      return { ...state, offlineRequest: payload };
    case RESET_LIFE:
      return init;
    default:
      return { ...state };
  }
};
